import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useWorktime = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getWorktimeByBranchDay = async ({ branchId, day }) => {
    try {
      const responseData = await sendRequest({
        url: `/api/v1/worktime/by/branch/${branchId}/day/${day}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return responseData;
    } catch (err) {
      console.error('error in useCall getOpenCallbacks:', err);
      return [];
    }
  };

  return {
    isLoading,
    error,
    getWorktimeByBranchDay,
  };
};

export default useWorktime;
